import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Scrolls to the element matching the current URL hash, re-running whenever
 * the hash changes (e.g. clicking a same-page nav link) or once data loads.
 * When the hash is cleared (e.g. clicking "Home" after "Gallery"), scrolls
 * back to the top instead of doing nothing. */
export function useHashScroll(ready) {
  const { hash } = useLocation();
  useEffect(() => {
    if (!ready) return undefined;
    const timer = setTimeout(() => {
      if (hash) document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth", block: "start" });
      else window.scrollTo({ top: 0, behavior: "smooth" });
    }, 50);
    return () => clearTimeout(timer);
  }, [ready, hash]);
}
